import snakeCaseKeys from 'snakecase-keys';
import { v4 as uuidv4 } from 'uuid';

import { omitDeep, sortObjByKeys } from '@/utilities';
import { Base } from '@/models';

export class CognitoBase extends Base {
 
  /**
   * Constructor
   */
  public constructor(data: any) {
    super(data);
  }

	/**
   * Create a JSON representation of this object and it's descedents.
   *
   * @return {Object}
   */
	 public toJSON() {
		// Convert object camelCase keys into snake_case
		const json = super.toJSON();

		// key sort
		return sortObjByKeys(json);
	}

}
